import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export const Title = styled.h1`
  text-align: center;
  font-family: sans-serif;
  font-size: 1.35rem;
  line-height: 1.1;
  font-weight: 700;

  padding-top: 32px;
  padding-bottom: 24px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 900px;
  margin: auto;
`;

export const FieldGroup = styled.div<{ $hidden?: boolean }>`
  display: ${(props) => (props.$hidden ? 'none' : `flex`)};
  align-items: center;
  justify-content: center;
  min-height: 31px;
  margin-right: auto;
  margin-left: auto;
  width: 100%;
  margin: 3px 0px;
`;

export const Label = styled.p`
  flex: 0.333%;
  margin-right: 12px;
  font-weight: 600;
  color: #3b3b3b;
  font-size: 0.5rem;
`;

export const FieldLabel = styled.label`
  font-weight: 600;
  width: 25%;
  text-align: right;
  margin-right: 12px;
`;

export const ErrorWrapper = styled.div`
  flex: 0 0 300px;
  min-width: 0;
  display: flex;
  align-items: center;
  overflow-wrap: anywhere;
`;

export const ErrorBlockWrapper = styled.div`
  margin-bottom: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  margin-left: 545px;
`;

export const Error = styled.p`
  color: ${COLORS.DARK_RED};
  font-size: 0.875rem;
  margin-left: 0.6rem;
`;

export const ActionsContainer = styled.div`
  width: '300px';
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
  justify-self: center;
`;
